function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1908(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45.73,
    height: 33.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.536666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 16.61,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.22,
    width: 45.73,
    height: 34.83,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 50.635,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68.05,
    width: 45.73,
    height: 37.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 86.91,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105.77,
    width: 45.73,
    height: 40.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.781428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 126.005,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146.24,
    width: 45.73,
    height: 41.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9383333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 167.055,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 187.86,
    width: 45.73,
    height: 43.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.211666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 209.495,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.13,
    width: 45.73,
    height: 46.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 254.515,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.91,
    width: 45.73,
    height: 47.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.145999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 301.735,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 325.56,
    width: 45.73,
    height: 49.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.71625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 350.255,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 374.95,
    width: 45.73,
    height: 51.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.4325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 400.88,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 426.81,
    width: 45.73,
    height: 53.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.532857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 453.34000000000003,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 479.87,
    width: 45.73,
    height: 53.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 506.51,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 533.15,
    width: 45.73,
    height: 55.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.532857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 560.67,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 588.19,
    width: 45.73,
    height: 55.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.532857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 616,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 643.81,
    width: 45.73,
    height: 56.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.532857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.865,
    y: 671.905,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 0,
    width: 51.05,
    height: 50.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.255,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.78,
    y: 0,
    width: 51.18,
    height: 50.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.37,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.97,
    y: 0,
    width: 51.81,
    height: 50.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.875,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.78,
    y: 0,
    width: 52.25,
    height: 50.42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.905,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.03,
    y: 0,
    width: 53.43,
    height: 50.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.745,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.46,
    y: 0,
    width: 54.18,
    height: 50.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.084
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.54999999999995,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 0,
    width: 55.57,
    height: 50.42,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.084
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.425,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.21,
    y: 0,
    width: 56.17,
    height: 50.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.29499999999996,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.37,
    y: 0,
    width: 56.96,
    height: 50.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.202857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.85,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.33,
    y: 0,
    width: 57.07,
    height: 50.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.084
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.865,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.4,
    y: 0,
    width: 57.23,
    height: 50.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.015,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.63,
    y: 0,
    width: 57.37,
    height: 50.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.084
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.3149999999999,
    y: 25.21,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 50.42,
    width: 58.28,
    height: 50.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 75.47,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 100.52,
    width: 58.28,
    height: 50.44,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.406666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 125.74,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 150.96,
    width: 58.28,
    height: 51.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 176.82500000000002,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 202.69,
    width: 58.28,
    height: 52.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.402
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 228.695,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 254.7,
    width: 58.28,
    height: 52.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 280.91999999999996,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 307.14,
    width: 58.28,
    height: 53.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.68125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 333.865,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 360.59,
    width: 58.28,
    height: 54.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.77375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 387.68499999999995,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 414.78,
    width: 58.28,
    height: 55.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.211111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 442.72999999999996,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 470.68,
    width: 58.28,
    height: 56.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 498.735,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 526.79,
    width: 58.28,
    height: 56.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 555.25,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 583.71,
    width: 58.28,
    height: 57.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 612.6800000000001,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.73,
    y: 641.65,
    width: 58.28,
    height: 58.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.87,
    y: 670.8249999999999,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 50.42,
    width: 57.64,
    height: 60.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.234285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.83,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.65,
    y: 50.42,
    width: 57.87,
    height: 60.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.267142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.585,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.52,
    y: 50.42,
    width: 58.06,
    height: 60.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.55,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.58,
    y: 50.42,
    width: 58.16,
    height: 60.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.462222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 306.65999999999997,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.74,
    y: 50.42,
    width: 58.35,
    height: 60.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.915,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.09,
    y: 50.42,
    width: 58.44,
    height: 60.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.30999999999995,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.53,
    y: 50.42,
    width: 60.64,
    height: 60.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.84999999999997,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.18,
    y: 50.42,
    width: 61.39,
    height: 60.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.61625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.875,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.57,
    y: 50.42,
    width: 62.36,
    height: 60.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.75,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.93,
    y: 50.42,
    width: 63.07,
    height: 60.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.4649999999999,
    y: 80.885,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 111.35,
    width: 64.06,
    height: 60.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.033333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 141.45,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 171.55,
    width: 64.06,
    height: 61.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.290000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 202.42000000000002,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 233.29,
    width: 64.06,
    height: 63.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 265.07,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 296.86,
    width: 64.06,
    height: 63.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.754000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 328.745,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 360.62,
    width: 64.06,
    height: 65.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 393.16,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 425.7,
    width: 64.06,
    height: 65.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 458.65,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 491.6,
    width: 64.06,
    height: 68.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.117777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 525.695,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 559.79,
    width: 64.06,
    height: 68.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.812000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 594.175,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.01,
    y: 628.56,
    width: 64.06,
    height: 71.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.676666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.04000000000002,
    y: 664.28,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 111.35,
    width: 63.33,
    height: 73.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.8325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.73499999999999,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.41,
    y: 111.35,
    width: 63.8,
    height: 73.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.31,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.21,
    y: 111.35,
    width: 64.02,
    height: 73.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.21999999999997,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.23,
    y: 111.35,
    width: 64.69,
    height: 73.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.1725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.57500000000005,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.92,
    y: 111.35,
    width: 68.13,
    height: 73.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.354999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.985,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.04,
    y: 111.35,
    width: 68.69,
    height: 73.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.869
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.385,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.73,
    y: 111.35,
    width: 68.78,
    height: 73.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.756
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.12,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.52,
    y: 111.35,
    width: 70.48,
    height: 73.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.76,
    y: 148.265,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 185.18,
    width: 76.45,
    height: 68.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.295,
    y: 219.56,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 253.94,
    width: 76.45,
    height: 69.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.962
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.295,
    y: 288.845,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 323.75,
    width: 76.45,
    height: 70.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.295,
    y: 358.97,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 394.19,
    width: 76.45,
    height: 73.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.295,
    y: 430.7,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 467.21,
    width: 76.45,
    height: 74.12,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.235555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.295,
    y: 504.27,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 541.34,
    width: 76.45,
    height: 77.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.290000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.295,
    y: 580.08,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 618.82,
    width: 76.45,
    height: 81.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6450000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.295,
    y: 659.4100000000001,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 185.18,
    width: 86.64,
    height: 76.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.925714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.84000000000003,
    y: 223.42000000000002,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.16,
    y: 185.18,
    width: 87.04,
    height: 76.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.746666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.68,
    y: 223.42000000000002,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.2,
    y: 185.18,
    width: 88.16,
    height: 76.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.497777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.28,
    y: 223.42000000000002,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.35,
    y: 185.18,
    width: 96.17,
    height: 76.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.296000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.4350000000001,
    y: 223.42000000000002,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.52,
    y: 185.18,
    width: 97.48,
    height: 76.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.925714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.26,
    y: 223.42000000000002,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 261.66,
    width: 106.63,
    height: 73.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.308333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.83500000000004,
    y: 298.58500000000004,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 335.5,
    width: 106.63,
    height: 74.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.404999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.83500000000004,
    y: 372.525,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 409.55,
    width: 106.63,
    height: 86.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.7675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.83500000000004,
    y: 452.62,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 495.69,
    width: 106.63,
    height: 89.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.961666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.83500000000004,
    y: 540.575,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 585.45,
    width: 106.63,
    height: 114.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.326
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.83500000000004,
    y: 642.725,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.15,
    y: 261.66,
    width: 99.55,
    height: 169.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.92499999999995,
    y: 346.40500000000003,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.7,
    y: 261.66,
    width: 109.85,
    height: 169.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.625,
    y: 346.40500000000003,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.55,
    y: 261.66,
    width: 139.45,
    height: 169.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.43125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.275,
    y: 346.40500000000003,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.15,
    y: 431.14,
    width: 165.31,
    height: 268.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.66375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.80499999999995,
    y: 565.5699999999999,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.46,
    y: 431.14,
    width: 183.54,
    height: 268.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 608.23,
    y: 565.5699999999999,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1908);
export default __webpack_public_path__ + "static/media/1908.6474e028bf90b680b387af11f87f1fdf.svg";
export { ForwardRef as ReactComponent };